<ng-container *ngIf="control">
  <label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
  <input type="text"
         pattern="[0-9]+([\.,][0-9]+)?"
         class="esf-form-item__field"
         (change)="checkForComma($event)"
         (focusout)="checkForComma($event)"
         [placeholder]="placeholder"
         [formControl]="formControl"
         [id]="id">
</ng-container>

<ng-container *ngIf="!control">
  <label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
  <input type="text"
         pattern="[0-9]+([\.,][0-9]+)?"
         class="esf-form-item__field"
         [placeholder]="placeholder"
         [value]="inputValue"
         [(ngModel)]="inputValue"
         (change)="checkForComma($event)"
         (focusout)="checkForComma($event)"
         [id]="id">
</ng-container>
